export default "__VITE_ASSET__CBMvqY16__"